import { useState, useEffect } from "react";
import { cn } from "@/lib/utils";

const COOKIE_KEY = "flow-clock-cookie-ok";

export function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(COOKIE_KEY)) {
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  if (!visible) return null;

  const accept = () => {
    localStorage.setItem(COOKIE_KEY, "1");
    setVisible(false);
  };

  return (
    <div
      className={cn(
        "fixed bottom-4 left-4 right-4 z-50 mx-auto max-w-md",
        "rounded-2xl bg-card/95 backdrop-blur-xl border border-border/60",
        "p-4 shadow-lg animate-fade-in flex items-center gap-3"
      )}
    >
      <span className="text-xs text-muted-foreground leading-relaxed flex-1">
        🍪 We only use essential cookies to keep the app running.{" "}
        <a href="/privacy" className="underline hover:text-foreground transition-colors">
          Learn more
        </a>
      </span>
      <button
        onClick={accept}
        className="shrink-0 rounded-xl bg-primary text-primary-foreground text-xs font-semibold px-4 py-2 hover:opacity-90 active:scale-95 transition-all"
      >
        OK
      </button>
    </div>
  );
}
